import React, { useEffect, useState } from 'react';
import { Card } from './ui/card';
import { Switch } from './ui/switch';
import { Eye, EyeOff, History } from 'lucide-react';
import { api } from '../lib/api';
import { toast } from 'sonner';

export const ConsentPanel = () => {
  const [d, setD] = useState(null);
  const load = () => api.get('/consents').then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!d || d.shares.length === 0) return null;

  const toggle = async (s, v) => {
    await api.post(`/share/${s.share_id}/consent`, { granted: v });
    toast.success(v ? 'Sharing resumed — your worker can see your progress again' : 'Sharing paused — your worker now only sees that you claimed the checklist');
    load();
  };

  return (
    <Card className="p-5 mb-6 bg-card" data-testid="consent-panel">
      <div className="font-semibold flex items-center gap-2" style={{fontFamily: 'Lexend'}}><Eye className="w-4 h-4 text-[#1E5888]" /> Who can see my progress</div>
      <p className="text-sm text-muted-foreground mt-1">You control this. Pausing hides your application statuses from the worker and their agency instantly; they never see your documents or notes.</p>
      <ul className="mt-3 space-y-2">
        {d.shares.map((s) => {
          const on = s.consent ? s.consent.granted : true;
          return (
            <li key={s.share_id} className="flex items-center justify-between gap-3 rounded-lg border border-border p-3 text-sm" data-testid={`consent-row-${s.share_id}`}>
              <div className="min-w-0"><div className="font-medium">{s.worker_name || 'Your worker'}{s.organization ? ` · ${s.organization}` : ''}</div><div className="text-xs text-muted-foreground">{s.program_ids.length} programs · {on ? 'sharing progress' : 'paused'}{s.consent?.at ? ` since ${new Date(s.consent.at).toLocaleDateString()}` : ''}</div></div>
              <div className="flex items-center gap-2">{on ? <Eye className="w-4 h-4 text-primary" /> : <EyeOff className="w-4 h-4 text-muted-foreground" />}<Switch checked={on} onCheckedChange={(v) => toggle(s, v)} aria-label="Share progress with this worker" data-testid={`consent-toggle-${s.share_id}`} /></div>
            </li>
          );
        })}
      </ul>
      {d.log.length > 0 && <details className="mt-3 text-xs text-muted-foreground"><summary className="cursor-pointer flex items-center gap-1"><History className="w-3 h-3" /> Consent history ({d.log.length})</summary><ul className="mt-1 space-y-0.5" data-testid="consent-log">{d.log.slice(0, 10).map((l, i) => <li key={i}>{new Date(l.at).toLocaleString()} — {l.action} ({l.source})</li>)}</ul></details>}
    </Card>
  );
};
